import { useStore } from '../../../../../store/mst';
import { VisitDtoModelType } from '../../../../../store/mst/models';

interface UseOrderNavigationReturn {
  handleClose: () => void;
  onBackEvent: (() => void) | undefined;
}

export const useOrderNavigation = (visit?: VisitDtoModelType): UseOrderNavigationReturn => {
  const { router } = useStore();

  const handleClose = () => {
    router.navigateToRouteResource(
      { routeUuid: null, stopUuid: null, orderUuid: null },
      { deselectRoute: true, deselectStop: true, deselectOrder: true },
    );
  };

  const handleBackEvent = () => {
    const eventUuid = visit?.timeline?.eventUuid;
    if (eventUuid) {
      router.navigateToRouteResource({ stopUuid: eventUuid }, { deselectOrder: true });
    }
  };

  return {
    handleClose,
    onBackEvent: visit?.isScheduled ? handleBackEvent : undefined,
  };
};
